import {Modal, PrimaryButton, SecondaryButton} from 'components';
import React from 'react';
import DownloadImage from '../components/DownloadImage';

function SaveOrPublish({open, setOpen, onPublish, pLoading, pDisabled}) {
  return (
    <Modal
      show={open}
      onClose={() => setOpen(false)}
      extraModalClasses="max-w-[641px] w-full bg-white rounded-lg shadow-xl"
      modalPosition="fixed inset-0 flex items-center justify-center p-4"
      modalTitle="Confirm and Publish Rules"
      contentPadding="!p-6"
    >
      <div className=" mx-auto pt-12">
        <div
          className="w-[68px] h-[68px] rounded-full bg-[#EEF3FC] flex items-center justify-center
    mx-auto mb-6"
        >
          <DownloadImage />
        </div>
        <h1 className="text-[24px] text-[#080917] font-semibold text-center mb-4 px-32">
          Confirm you want to Publish these rules.
        </h1>
        <p className="text-center text-body px-10">
          Publishing will create a new version of this flow with the current
          rules. You can continue editing it without affecting previous
          versions.
        </p>
      </div>
      <div className="flex items-center gap-4 justify-center flex-wrap mt-12 mb-6">
        <PrimaryButton
          buttonText="Confirm and Publish Rules"
          className="w-[259px] !h-[52px]"
          onClick={onPublish}
          loading={pLoading}
          disabled={pDisabled}
        />
        <SecondaryButton
          onClick={() => setOpen(false)}
          buttonText="Cancel"
          className="!h-[52px] w-[259px] flex items-center justify-center !outline-[#DFE1E7] !text-[#033971] flex-row-reverse gap-1"
        />
      </div>
    </Modal>
  );
}

export default SaveOrPublish;
